import {priority} from '@priority-software/priority-proto-api/lib';

import {IExtendedCondition, ISearchCondition, ISearchFilter} from '../../types/filters';
import {ApiOperatorMapping, RangeApiOperatorMapping} from '../../types/operator';

function buildQuery(filter: ISearchCondition): IExtendedCondition[] {
    const {values, columnID, operator, columnName} = filter;

    const op = operator
        ? ApiOperatorMapping[operator]
        : priority.netitems.shared.ComparisonOperator.Eq;

    if (op !== priority.netitems.shared.ComparisonOperator.Between) {
        return [
            {
                Values: [values[0]],
                Operator: op,
                ColumnID: columnID,
                ColumnName: columnName
            }
        ];
    }

    return [
        {
            Values: values,
            Operator: op,
            ColumnID: columnID,
            ColumnName: columnName
        }
    ];
}

function serialize(condiions: priority.netitems.form.ICondition[]): ISearchFilter {
    const filter = condiions[0];
    const {Values, Operator: queryOperator, ColumnID} = filter;
    const operator = RangeApiOperatorMapping[queryOperator];

    return {
        values: Values,
        operator,
        columnID: ColumnID
    };
}

export {buildQuery, serialize};
